import { useLocation, useNavigate } from "react-router-dom"
import React, { useEffect, useState } from 'react';
import styled from "styled-components"
import {ExclamationCircleOutlined} from "@ant-design/icons/lib/icons"
import { InputNumber,Modal } from 'antd';
import { Image,Button } from 'antd';
import { Typography } from 'antd';
import { deleteDoc, doc, onSnapshot, updateDoc,getDoc } from "firebase/firestore";
import { auth,db } from "../Config";
const { Title } = Typography;
export default function CartItem(){
    const InfoField = styled.div`
        width:88%;
        min-height:100vh;
        padding:16vh 3vw 2vh 15vw;
        @media (max-width:767px){
            width:95%;
            padding:16vh 3vw 2vh 0vw;
        }
    `
    const InfoContainer = styled.div`
        margin:0 10vw 0 5vw;
        width:80%;
        min-height:90vh;
        display:flex;
        background-color:#f5eedb;
        border-radius:30px;
        @media (max-width:1023px) and (min-width:768px){
            width:110%;
        }
        @media (max-width:767px){
            margin:0 5vw 0 5vw;
            width:100%;
            flex-direction:column;
            align-items:center;
        }
    `
    const ImgField = styled.div`
        width:25vw;
        height:100vh;
        padding:8vh 0 0 5vw;
        border-radius:20px;
        overflow: hidden;
        @media (max-width:1023px) and (min-width:768px){
            width:35vw;
        }
        @media (max-width:767px){
            height:50vh;
            width:80vw;
            padding:8vh 0 0 0vw;
            display: flex;
            margin-left:15vw;
        }
        .info-img{
            width:18vw;
            height:40vh;
            border-radius:20px;
            object-fit:cover;
            @media (max-width:1023px) and (min-width:768px){
                width:30vw;
            }
            @media (max-width:767px){
                width:100%;
                
            }
    }
    `
    const InfoContent = styled.div`
        margin:8vh 4vw 0 2vw;
        width:45%;
        height:100%;
        font-family: Arial, Helvetica, sans-serif;
        display:flex;
        flex-direction:column;
        @media (max-width:767px){
            width:70%;
        }
        .info-btn{
            width:20vw;
            height:8vh;
            margin-bottom:2vh;
            border-radius:10px;
            background-color:tomato;
            color:white;
            :hover{
                background-color:transparent;
                color:tomato;
                border:1px solid tomato
            }
            @media (max-width:767px){
                width:50vw;
            }  
        }
        
    `
    let location = useLocation()
    const navigate = useNavigate()
    const search = new URLSearchParams(location.search)
    const id = search.get('id')  
    const [cartItem,setCartItem] = useState()
    useEffect(()=>{
        const docRef = doc(db,'cartlist',auth.currentUser.uid,'cart',id) 
        onSnapshot(docRef,doc=>{
            setCartItem(doc.data())   
        })
    },[])
    const [user,setUser] = useState()
    useEffect(()=>{
        const docRef = doc(db,'users',auth.currentUser.uid)
        getDoc(docRef).then((doc)=>{
            setUser(doc.data())
        })
    },[])
    function onSizeChange(value) {
        const docRef = doc(db,'cartlist',auth.currentUser.uid,'cart',id) 
        updateDoc(docRef,{size:value})
    }
    function onNumberChange(value) {
        const docRef = doc(db,'cartlist',auth.currentUser.uid,'cart',id) 
        updateDoc(docRef,{number:value,
            totalCost:value*cartItem.costNum,
        })
    }
    function success() {
        Modal.success({
          content: 'Đã cập nhập thông tin đơn hàng',
        });
    }
    const handleSave = () => {
       success() 
    }
    const { confirm } = Modal;
    function error() {
        Modal.error({
          title: 'Lỗi',
          content: 'Thông tin người dùng không đầy đủ',
        });
    }    
    function showDeleteConfirm() {
        confirm({
          title: 'Bạn có chắc mua sản phẩm này chứ?',
          icon: <ExclamationCircleOutlined />,
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk() {
            if(user.fullInfo){
                const docRef = doc(db,'cartlist',auth.currentUser.uid,'cart',id) 
                deleteDoc(docRef).then(
                    ()=>{
                        navigate('/home/cart')
                    }
                )
            }else{
                error()           
            }
          },
          onCancel() {
            
          },
        });
      }
    function ImageDemo() {
        return (
          <Image
            className="info-img"
            src={cartItem.img}
          />
        );
      }
    if(cartItem){
        return(
            <InfoField>
                <InfoContainer>
                    <ImgField>
                        <ImageDemo />
                    </ImgField>
                    <InfoContent>
                        <Title level={4}>{cartItem.name}</Title>
                        <Title level={5} style={{marginTop:'0',color:'tomato'}}>{cartItem.cost}</Title>
                        <p>{cartItem.material}</p>
                        <p>Size(35-42):</p>
                        <InputNumber min={35} max={42} defaultValue={cartItem.size} style={{width:'20%',marginBottom:'2vh'}} onChange={onSizeChange}/>
                        <p>Số Lượng:</p>
                        <InputNumber min={1} defaultValue={cartItem.number} style={{width:'20%',marginBottom:'2vh'}} onChange={onNumberChange}/>
                        <Title level={5} style={{marginTop:'0',color:'tomato'}}>Tổng tiền: {cartItem.totalCost}đ</Title>
                        <Button className="info-btn" onClick={handleSave}>Lưu Lại</Button>
                        <Button className="info-btn" onClick={showDeleteConfirm}>Mua Hàng</Button>
                        <p>{cartItem.info}</p>
                    </InfoContent>
                </InfoContainer>
            </InfoField>
        )
    }
    else{
        return(<></>)
    }
}